const ClientSideStorage = require('@core/util/client-side-storage');
const ExpUtils = require('./ExpUtils');

module.exports = class ClientSideStorageWrapper {
  /**
   * Sets session
   * @param {string} sessionName
   * @param {object} data object
   */
   static setExpSession = (sessionName, data) => {
     ClientSideStorage.setSession(sessionName, JSON.stringify(data));
   }

   /**
    * Gets session
    * @param {*} sessionName
    * @returns
    */
  static getExpSession = (sessionName) => {
    if (ClientSideStorage.getSession(sessionName)) {
      return JSON.parse(ClientSideStorage.getSession(sessionName));
    }
    return undefined;
  }

  /**
   * Removes session
   * @param {*} sessionName
   */
  static removeExpSession= (sessionName) => {
    ClientSideStorage.removeSession(sessionName);
  }

  /**
   *
   * @param {string} sessionName
   * @param {string} data
   * Usage:
   */
  static setExpTagsSession = (sessionName = 'ExpMetaData', data) => {
    ClientSideStorage.setSession(sessionName, data);
  }

  /**
   * Usage:
   */
   static getExpTagsSession = (sessionName = 'ExpMetaData') => {
     if (ClientSideStorage.getSession(sessionName)) {
       return ClientSideStorage.getSession(sessionName);
     }
     return undefined;
   }

  /**
   * Usage:
   */
  static removeExpTagsSession = (sessionName = 'ExpMetaData') => {
    ClientSideStorage.removeSession(sessionName);
  }

  /**
   * Check session for tag name
   * @param {string} tagName
   * @returns
   * Usage:
   */
  static isTagFired = (tagName) => {
    const firedLinkClickTags = ClientSideStorage.getSession(tagName);
    const sessionExists = !!firedLinkClickTags;
    // if not in session (first time fired): store in session
    if (!sessionExists) {
      return false;
    }
    return true;
  }

  /**
   * Set tag name as fired in session
   * @param {string} tagName
   * Usage:
   */
  static sessionBasedLinkClickTagFired = (tagName) => {
    ClientSideStorage.setSession(tagName, new Date().toString());
  }

  /**
   * Is experimentation session expired
   * @returns {boolean}
   */
  static isExpSessionExpired = () => {
    const session = this.getExpSession(ExpUtils.PROPS.COMMON.expSessionKey);
    const now = new Date().getTime();
    // Remove Session Variable when expire
    // ttl = expire - now
    if (session && session.expires - now < 0) {
      this.removeExpSession(ExpUtils.PROPS.COMMON.expSessionKey);
      return true;
    }
    return false;
  }

  /**
   * Is experimentation tags session expired
   * @returns {boolean}
   */
  static isExpTagsSessionExpired = () => {
    const session = this.getExpTagsSession(ExpUtils.PROPS.COMMON.expTagsFiredSessionKey);
    const now = new Date().getTime();
    // Remove Session Variable when expire
    // ttl = expire - now
    if (session && session.split('|').length === 2
      && !Number.isNaN(session.split('|')[1]) && session.split('|')[1] - now > 0) {
      return false; // good session
    }
    this.removeExpTagsSession(ExpUtils.PROPS.COMMON.expTagsFiredSessionKey);
    return true; // bad session
  };

  /**
   * Formats /filteredExperiments api response
   */
  static mapResponse = (expData, selectedRecipes) => {
    let respObj = {};
    const mappings = {};
    let allTargetURLs = [];

    respObj = expData.reduce((experimentArr, campaign) => {
      // eslint-disable-next-line no-param-reassign
      experimentArr[campaign.analyticsId] = {
        id: campaign.analyticsId,
        tagType: campaign.tagType,
        taggingProvider: campaign.taggingProvider,
        experimentType: campaign.experimentType,
        adobeAutoTagging: campaign.adobeAutoTagging,
        recipes: campaign.recipes.reduce((recipeArr, recipe) => {
          // eslint-disable-next-line no-param-reassign
          recipeArr[recipe.id] = {
            id: recipe.id,
            tagName: recipe.tagName,
          };
          return recipeArr;
        }, {}),
        targetURLs: campaign.targetUrls,
        recipesType: campaign.recipesType,
        subTargets: campaign.subTargets
          ? campaign.subTargets.reduce((subTargetArr, subTarget) => {
            // eslint-disable-next-line no-param-reassign
            subTargetArr[subTarget.id] = {
              id: subTarget.id,
              name: subTarget.name,
              recipes: subTarget.targetedRecipes.reduce(
                (subRecipeArr, subRecipe) => {
                  // eslint-disable-next-line no-param-reassign
                  subRecipeArr[subRecipe.id] = {};
                  return subRecipeArr;
                },
                {},
              ),
              targetURLs: subTarget.segments.reduce(
                (segmentsArr, segment) => Array.from(new Set([...segmentsArr, ...segment.targetURLs])),
                {},
              ),
            };
            return subTargetArr;
          }, {})
          : [],
        qualifiedSubTarget: campaign.qualifiedSubTarget,
      };
      return experimentArr;
    }, {});

    const { GlobalHoldOut, expires, ...omittedRespObj } = respObj;
    const allCampaigns = Object.values(omittedRespObj);
    allCampaigns.forEach((campaign) => {
      allTargetURLs = Array.from(new Set([...allTargetURLs, ...campaign.targetURLs]));
    });
    allTargetURLs.forEach((targetUrl) => {
      allCampaigns.forEach((campaign) => {
        if (ExpUtils.includes(campaign.targetURLs, targetUrl)) {
          (
            mappings[targetUrl.targetUrl]
              || (mappings[targetUrl.targetUrl] = [])
          ).push(campaign.id);
        }
      });
    });
    respObj.urlCampaignMapping = mappings;
    if (selectedRecipes !== null) {
      respObj.selectedRecipes = selectedRecipes;
    }
    respObj.signedInUser = ExpUtils.getCookieForExperiment('macys_online_uid')
    || ExpUtils.getCookieForExperiment('bloomingdales_online_uid')
    || 0;

    if (ExpUtils.PROPS.env === undefined) {
      ExpUtils.setEnv();
    }

    if (ExpUtils.PROPS.env === 'DESKTOP') {
      respObj.expires = new Date().getTime() + ExpUtils.PROPS.COMMON.sessionTTL;
    } else {
      respObj.expires = new Date().getTime() + ExpUtils.PROPS.MEW.sessionTTL;
    }
    return respObj;
  }
};
